import Order, { ArticleOrderDraft, ItemOrderDraft } from '../Order';

export default (order: Order): boolean => {
    return order.articlesOrdersDrafts.some((articleOrderDraft: ArticleOrderDraft) => {
        return articleOrderDraft.itemsOrdersDrafts.some((itemOrderDraft: ItemOrderDraft) => {
            return itemOrderDraft.toOrderFromStock !== 0 || itemOrderDraft.toOrderFromEstimation !== 0;
        });
    });
};



// WEBPACK FOOTER //
// ./src/domain/estimations/containsAtLeastOneNotSavedOrder.ts